var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShiny(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512.736 512.736",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512.736 512.736"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd83b"
    },
    d: "M238,512.736c0-76.8-128.544-205.344-205.344-205.344c76.8,0,205.344-128.544,205.344-205.344 c0,76.8,128.544,205.344,205.344,205.344C366.544,307.392,238,435.936,238,512.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3c432"
    },
    d: "M238,388.272c0-30.24-50.64-80.88-80.88-80.88c30.24,0,80.88-50.64,80.88-80.88 c0,30.24,50.64,80.88,80.88,80.88C288.624,307.392,238,358.016,238,388.272z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd83b"
    },
    d: "M381.168,226.512c0-36.992-61.92-98.912-98.912-98.912c36.992,0,98.912-61.92,98.912-98.912 c0,36.992,61.92,98.912,98.912,98.912C443.088,127.6,381.168,189.52,381.168,226.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd83b"
    },
    d: "M92.976,505.36c0-19.056-31.888-50.944-50.944-50.944c19.056,0,50.944-31.888,50.944-50.944 c0,19.056,31.888,50.944,50.944,50.944C124.864,454.432,92.976,486.32,92.976,505.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd83b"
    },
    d: "M158.688,141.408c0-26.448-44.256-70.704-70.704-70.704c26.448,0,70.704-44.256,70.704-70.704 c0,26.448,44.256,70.704,70.704,70.704C202.944,70.704,158.688,114.96,158.688,141.408z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiny);
export default __webpack_public_path__ + "static/media/shiny.9053c24afb97dc348a32a636ec8552a2.svg";
export { ForwardRef as ReactComponent };